import axios from 'axios';
import {
    REMOVE_USER_ROOM,
    REMOVE_USER_ROOMMATE,
    SET_TOKEN,
    SET_USER,
    SET_USER_ROOM,
} from '../constants/mutations';

const state = {
    token: null,
    user: null,
};

const getters = {
    isAuthenticated: (state) => state.user !== null,
    user: (state) => state.user,
};

const actions = {
    setUserRoom({ commit }, room) {
        commit(SET_USER_ROOM, room);
    },
    async getUserInfo({ commit }) {
        const { data: user } = await axios.get('/api/users/me').catch(() => {
            window.localStorage.removeItem('kolireg-token');
        });
        commit(SET_USER, user);
    },
    async login({ commit, dispatch }) {
        let token = window.localStorage.getItem('kolireg-token');
        if (!token) {
            const { data } = await axios.post('/tokens/create');
            if (data.token == null) {
                return null;
            }
            token = data.token;
            window.localStorage.setItem('kolireg-token', token);
        }

        axios.defaults.headers = {
            Authorization: `Bearer ${token}`,
        };
        setTimeout(() => {
            commit(SET_TOKEN, token);
        }, 10);

        const { data: user } = await axios.get('/api/users/me').catch(() => {
            window.localStorage.removeItem('kolireg-token');
        });
        commit(SET_USER, user);

        if (user?.room_number) {
            dispatch('Popup/selectRoom', user.room_number, { root: true });
        }

        return user;
    },
    async logout({ commit, dispatch }) {
        await axios.post('/tokens/destroy');
        commit(SET_USER, null);
        window.localStorage.removeItem('kolireg-token');
        dispatch('Room/resetRooms', {}, { root: true });
    },
};

const mutations = {
    [SET_TOKEN](state, token) {
        state.token = token;
    },
    [SET_USER](state, user) {
        state.user = user;
    },
    [SET_USER_ROOM](
        state,
        { reservationId, room, roommate, status, roommateStatus, roommateReservationId, by }
    ) {
        if (typeof reservationId !== 'undefined') {
            state.user.reservation_id = reservationId;
        }
        if (typeof room !== 'undefined') {
            state.user.room_number = room;
        }
        if (typeof status !== 'undefined') {
            state.user.reservation_status = status;
        }
        if (typeof roommate !== 'undefined') {
            state.user.roommate = roommate;
        }
        if (typeof roommateStatus !== 'undefined') {
            state.user.roommate_status = roommateStatus;
        }
        if (typeof roommateReservationId !== 'undefined') {
            state.user.roommate_reservation_id = roommateReservationId;
        }
        if (typeof by !== 'undefined') {
            state.user.reserved_by = by;
        }
    },
    [REMOVE_USER_ROOM](state) {
        delete state.user.reservation_id;
        delete state.user.room_number;
        delete state.user.reservation_status;
        delete state.user.roommate;
        delete state.user.roommate_status;
        delete state.user.roommate_reservation_id;
        delete state.user.reserved_by;
    },
    [REMOVE_USER_ROOMMATE]() {
        delete state.user.roommate;
        delete state.user.roommate_status;
        delete state.user.roommate_reservation_id;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
